$(document).on(
  "revelation_assassin_footer rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
  }
);
